import { TEnvironmentVariableDTO } from "Types";

export class EnvironmentLogic {
    findDuplicatedEnvironmentVariableInList = (environmentVariable: string, environmentVariableList: TEnvironmentVariableDTO[]): TEnvironmentVariableDTO | undefined => {
        // safety-checks
        if (!environmentVariable || !environmentVariableList) return undefined;
        
        for (const environmentVar of environmentVariableList) {
            if (environmentVar.environment.trim().toLowerCase() === environmentVariable.trim().toLowerCase()) return environmentVar;
        }

        return undefined;
    };

}

export const EnvironmentLogicSingleton = new EnvironmentLogic();